"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThanksSubTitle = exports.InitialPromptAnswer = exports.ModalPhase = void 0;
var ModalPhase;
(function (ModalPhase) {
    ModalPhase["Start"] = "start";
    ModalPhase["Positive"] = "positive";
    ModalPhase["Negative"] = "negative";
})(ModalPhase = exports.ModalPhase || (exports.ModalPhase = {}));
var InitialPromptAnswer;
(function (InitialPromptAnswer) {
    InitialPromptAnswer["Yes"] = "Yes, this care option is helpful";
    InitialPromptAnswer["No"] = "No, this care option is not helpful";
})(InitialPromptAnswer = exports.InitialPromptAnswer || (exports.InitialPromptAnswer = {}));
var ThanksSubTitle;
(function (ThanksSubTitle) {
    ThanksSubTitle["Positive"] = "One last thing \u2013 what did you like about this care option?";
    ThanksSubTitle["Negative"] = "One last thing \u2013 where did we go wrong?";
})(ThanksSubTitle = exports.ThanksSubTitle || (exports.ThanksSubTitle = {}));
const feedbackQuestions = {
    [ModalPhase.Start]: {
        title: "Great! Your feedback helps Buoy get smarter.",
        questions: [
            {
                inputType: "radio",
                prompt: "Is this care option helpful?",
                options: [
                    InitialPromptAnswer.Yes,
                    InitialPromptAnswer.No
                ],
            },
        ],
    },
    [ModalPhase.Positive]: {
        title: "Thanks for your feedback!",
        subTitle: ThanksSubTitle.Positive,
        questions: [
            {
                inputType: "multiSelect",
                options: [
                    "It helped me decide what to do next",
                    "The information was easy to understand",
                    "This care option addresses my health concern",
                    "It’s a high-quality care option",
                    "Something else",
                ],
                multiSelect: true,
            },
            {
                prompt: "Share any additional thoughts about the Buoy experience here. (The more, the better.)",
                inputType: "text",
            },
        ],
    },
    [ModalPhase.Negative]: {
        title: "Thanks for your feedback!",
        subTitle: ThanksSubTitle.Negative,
        questions: [
            {
                inputType: "multiSelect",
                options: [
                    "This didn’t help me decide what to do next",
                    "The information was confusing",
                    "This care option is not relevant",
                    "I don’t like this care option",
                    "Something else",
                ],
                multiSelect: true,
            },
            {
                prompt: "Share any additional thoughts about the Buoy experience here. (The more, the better.)",
                inputType: "text",
            },
        ],
    },
};
exports.default = feedbackQuestions;
//# sourceMappingURL=feedbackQuestions.js.map